import actionTypes from "../actionTypes";
export const addRemoveFavoriteSeriesAction = () => ({
  type: actionTypes.seriesTypes.ADD_REMOVE_FAVORITE_SERIES,
});

export const getClassesBySeriesIdAction = (data) => ({
  type: actionTypes.seriesTypes.GET_CLASSES_BY_SERIESID,
  payload: data,
});
